<!-- =========================================================================================
	File Name: ECommerceCheckout.vue
	Description: eCommerce Checkout page
	----------------------------------------------------------------------------------------
	Item Name: Vuesax Admin - VueJS Dashboard Admin Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="ecommerce-checkout-demo">
        <form-wizard
            ref="checkoutWizard"
            color="rgba(var(--vs-primary), 1)"
            :title="null"
            :subtitle="null"
            :hide-buttons="true">

            <!-- tab 1 content -->
            <tab-content title="Inicio" icon="feather icon-home" class="mb-5">

                <!-- IF CART HAVE ITEMS -->
                <div class="vx-row" v-if="cartItems.length">

                    <!-- LEFT COL -->
                    <div class="vx-col lg:w-2/3 w-full relative">
                        <div class="items-list-view" v-for="(item, index) in cartItems" :key="item.objectID">
                            <item-list-view :item="item">

                                <!-- SLOT: ITEM META -->
                                <template slot="item-meta">
                                    <h6 class="item-name font-semibold mb-1">{{ item.name }}</h6>
                                    <p class="text-sm mb-2 cursor-pointer">CNPJ <span class="text-primary font-semibold">{{ item.cnpj }}</span></p>
                                    <p class="text-success text-sm">Investimento Disponível</p>

                                    <p class="mt-4 font-bold text-sm">Parcelas</p>
                                    <vs-input-number min="1" max="10" :value="item.parcelas" disabled class="inline-flex" />
                                    <div class="vx-col sm:w-1/2 w-full">

                                        <vs-input
                                            v-validate="'required'"
                                            name="invest"
                                            label="Valor do Investimento"
                                            v-model.lazy="invest" v-money="money"
                                            class="w-full mt-5" />
                                        <span v-show="errors.has('add-new-address.mobileNum')" class="text-danger">{{ errors.first('add-new-address.mobileNum') }}</span>
                                    </div>

                                    <p class="font-medium text-grey mt-4">Investimento Mínimo: {{ item.invest_minimo }}</p>
                                    <p class="font-medium text-grey mt-4">Data prevista de inicio: {{ item.delivery_date }}</p>
                                    <p class="text-success font-medium">{{ item.tax_aa }}%/a.a</p>
                                </template>

                                <!-- SLOT: ACTION BUTTONS -->
                                <template slot="action-buttons">

                                    <!-- PRIMARY BUTTON: REMOVE -->
                                    <div class="item-view-primary-action-btn p-3 rounded-lg flex flex-grow items-center justify-center cursor-pointer mb-3" @click="removeItemFromCart(item)">
                                        <feather-icon icon="XIcon" svgClasses="h-4 w-4" />
                                        <span class="text-sm font-semibold ml-2">REMOVER</span>
                                    </div>

                                </template>
                            </item-list-view>
                        </div>
                    </div>

                    <!-- RIGHT COL -->
                    <div class="vx-col lg:w-1/3 w-full">
                        <vx-card>


                            <p class="font-semibold mb-3">Informações do Investimento</p>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Total Aplicação</span>
                                <span>{{invest}}</span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Lucro/Mês</span>
                                <span class="text-success">R$ {{lucro_mes}}</span>
                            </div>
                            <div class="flex justify-between mb-2">
                                <span class="text-grey">Lucro Previsto</span>
                                <span class="text-success">R$ {{lucro_ano}}</span>
                            </div>

                            <vs-divider />

                            <div class="flex justify-between font-semibold mb-3">
                                <span>Lucro Bruto</span>
                                <span>R$ {{lucro_bruto}}</span>
                            </div>

                            <vs-button class="w-full" @click="$refs.checkoutWizard.nextTab()">CONTINUAR</vs-button>
                        </vx-card>
                    </div>
                </div>

                <!-- IF NO ITEMS IN CART -->
                <vx-card title="Você não selecionou nenhum investimento" v-else>
                    <vs-button @click="$router.push('/p2p/investimento/localizar')">Procurar Investimento</vs-button>
                </vx-card>

            </tab-content>

            <!-- tab 2 content -->
            

            <!-- tab 3 content -->
            <tab-content title="Pagamento" icon="feather icon-credit-card" class="mb-5">

                <div class="vx-row">

                    <!-- LEFT COL: PAYMENT OPTIONS -->
                    <div class="vx-col lg:w-2/3 w-full">
                        <vx-card title="Formas de Pagamento" subtitle="Selecione a opção correta">

                            <div class="mt-3">
                                <ul>
                                  <!-- OPTION 1 -->
                                  <li>
                                    <!-- CARD DETAILS -->
                                    <div class="flex flex-wrap justify-between items-center">
                                        <vs-radio v-model="paymentMethod" vs-value="debit-card">
                                            <div class="flex items-center">
                                                <img src="@/assets/images/logo/logo.png" alt="bank-logo" height="40" width="50" class="inline-flex">
                                                <span>Conta UzePay</span>
                                            </div>
                                        </vs-radio>
                                    </div>

                                    <!-- CVV BLOCK -->
                                    <form data-vv-scope="cvv-form" class="mt-4">
                                        <div class="flex items-center">
                                            <span>Digite o seu PIN: </span>
                                            <vs-input
                                                v-validate="'required|min:4'"
                                                name="cvv"
                                                v-model="cvv"
                                                class="mr-3 ml-2" />
                                            <vs-button @click.prevent="makePayment" :disabled="false">FINALIZAR</vs-button>
                                        </div>
                                        <span v-show="errors.has('cvv-form.cvv')" class="text-danger ml-24">{{ errors.first('cvv-form.cvv') }}</span>
                                    </form>
                                  </li>


                                  
                                </ul>


                            </div>
                        </vx-card>
                    </div>

                    <!-- RIGHT COL: PRICE -->
                    <div class="vx-col lg:w-1/3 w-full">
                        <vx-card title="Informações do Pagamento">

                            <div class="flex justify-between mb-2">
                                <span>Pagamento Total</span>
                                <span class="font-semibold">{{invest}}</span>
                            </div>
                            

                            <vs-divider />

                            <div class="flex justify-between">
                                <span>Saldo Disponível</span>
                                <span class="font-semibold">R$ {{saldo}}</span>
                            </div>
                        </vx-card>
                    </div>
                </div>
            </tab-content>

        </form-wizard>
    </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {VMoney} from 'v-money'
const ItemListView = () => import('./components/ItemListView.vue')
var assert = require('assert')


export default {
    data() {
        return {

            // TAB 2
            investimento: "",
            invest: "100000",
            saldo: "",
            pincode: "",
            houseNum: "",
            area: "",
            landmark: "",
            city: "",
            state: "",
            bruto: 0,
            addressType: 1,
            addressTypeOptions: [
                { text: 'Home', value: 1 },
                { text: 'Office', value: 2 },
            ],
            money: {
              decimal: ',',
              thousands: '.',
              prefix: 'R$ ',
              suffix: '',
              precision: 2,
              masked: false /* doesn't work with directive */
            },

            // TAB 3
            paymentMethod: "debit-card",
            cvv: '',
        }
    },
    computed: {
        lucro_mes() {
            var tax_am = this.roundToXDigits(this.$store.state.p2p.cartItems[0].tax_aa/12,2);
            
            var valore = this.roundToXDigits(this.parseNumber(this.invest)/this.$store.state.p2p.cartItems[0].parcelas, 2);

            var teste = (valore*tax_am)/100;

            return this.roundToXDigits(teste*this.$store.state.p2p.cartItems[0].parcelas,2);
            //return this.juros_simples(valore, tax_aa, this.$store.state.p2p.cartItems[0].parcelas);
        },
        lucro_ano() {
            var tax_am = this.roundToXDigits(this.$store.state.p2p.cartItems[0].tax_aa/12,2);
            
            var valore = this.roundToXDigits(this.parseNumber(this.invest)/this.$store.state.p2p.cartItems[0].parcelas, 2);

            var teste = (valore*tax_am)/100;
            return this.roundToXDigits(this.roundToXDigits(teste*this.$store.state.p2p.cartItems[0].parcelas,2)*this.$store.state.p2p.cartItems[0].parcelas,2);
            //return this.juros_simples(valore, tax_aa, this.$store.state.p2p.cartItems[0].parcelas);
        },
        lucro_bruto() {
            var tax_am = this.roundToXDigits(this.$store.state.p2p.cartItems[0].tax_aa/12,2);
            
            var valore = this.roundToXDigits(this.parseNumber(this.invest)/this.$store.state.p2p.cartItems[0].parcelas, 2);

            var teste = (valore*tax_am)/100;
            this.bruto = this.roundToXDigits(this.parseNumber(this.invest)+this.roundToXDigits(teste*this.$store.state.p2p.cartItems[0].parcelas,2)*this.$store.state.p2p.cartItems[0].parcelas,2);
            return this.roundToXDigits(this.parseNumber(this.invest)+this.roundToXDigits(teste*this.$store.state.p2p.cartItems[0].parcelas,2)*this.$store.state.p2p.cartItems[0].parcelas,2);
            //return this.juros_simples(valore, tax_aa, this.$store.state.p2p.cartItems[0].parcelas);
        },
        cartItems() {
            return this.$store.state.p2p.cartItems.slice().reverse();
        },
        isInWishList() {
            return (itemId) => this.$store.getters['p2p/isInWishList'](itemId)
        },
    },
    methods: {

        // TAB 1
        calcParcelaJuros(valor_total, parcelas,juros){
            var valor = 0;
            for(var i=1;i<(parcelas+1);i++){
                var I =juros/100.00;
                var valor_parcela = valor_total*I*Math.pow((1+I),parcelas)/(Math.pow((1+I),parcelas)-1);
                valor+=valor_parcela;
            }
            return valor;
        },
        juros_simples(capital, taxa, n_periodos) {
            return capital * taxa * n_periodos;
        },
        roundToXDigits(value, digits)
        {
          if (!digits) {
            digits = 2;
          }

          value = value * Math.pow(10, digits);
          value = Math.round(value);
          value = value / Math.pow(10, digits);

          return value;
        },
        parseNumber(strg) {
          var strg = strg || "";
          var decimal = '.';
          strg = strg.replace(/[^0-9$.,]/g, '');
          strg = strg.replace('R', '');
          strg = strg.replace('$', '');
          strg = strg.replace(' ', '');
          if(strg.indexOf(',') > strg.indexOf('.')) decimal = ',';
          if((strg.match(new RegExp("\\" + decimal,"g")) || []).length > 1) decimal="";
          if (decimal != "" && (strg.length - strg.indexOf(decimal) - 1 == 3) && strg.indexOf("0" + decimal)!==0) decimal = "";
          strg = strg.replace(new RegExp("[^0-9$" + decimal + "]","g"), "");
          strg = strg.replace(',', '.');
          return parseFloat(strg);
        },
        removeItemFromCart(item) {
            this.$store.dispatch('p2p/toggleItemInCart', item)
        },
        wishListButtonClicked(item) {
            // Toggle in Wish List
            if (this.isInWishList(item.objectID)) this.$router.push('/apps/eCommerce/wish-list')
            else {
                this.toggleItemInWishList(item)
                this.removeItemFromCart(item)
            }
        },
        toggleItemInWishList(item) {
            this.$store.dispatch('p2p/toggleItemInWishList', item)
        },
        updateItemQuantity(event, index) {
            const itemIndex = Math.abs(index + 1 - this.cartItems.length)
            this.$store.dispatch("p2p/updateItemQuantity", { quantity: event, index: itemIndex })
        },
        updateItemInvest(event, index) {
            const itemIndex = Math.abs(index + 1 - this.cartItems.length)
            this.$store.dispatch("p2p/updateItemInvest", { invest: event, index: itemIndex })
        },

        // TAB 2
        submitNewAddressForm() {
            return new Promise(() => {
                this.$validator.validateAll('add-new-address').then(result => {
                    if (result) {
                        // if form have no errors
                        this.$refs.checkoutWizard.nextTab()
                    } else {
                        this.$vs.notify({
                            title: 'Error',
                            text: 'Please enter valid details',
                            color: 'warning',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    }
                })
            })
        },

        // TAB 3
        makePayment() {
            return new Promise(() => {
                this.$validator.validateAll('cvv-form').then(result => {
                    if (result) {
                        // if form have no errors this.roundToXDigits(this.parseNumber(this.invest), 2)
                        fetch(this.$store.state.API_URL + 'P2P/Investimento/Investir', {
                            method: 'POST',
                            headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
                            body: "token="+localStorage.getItem("token")+"&proposta="+this.$store.state.p2p.cartItems[0].objectID+"&price="+this.roundToXDigits(this.parseNumber(this.invest), 2)+"&bruto="+this.roundToXDigits(this.parseNumber(this.invest), 2)+"&pin="+this.cvv
                        })
                        .then((response) => response.text())
                        .then((responseData) => {

                            var dados = JSON.parse(responseData);
                            
                            if(dados.done == true)
                            {
                                this.$vs.notify({
                                    title: 'Investimento',
                                    text: dados.message,
                                    color: 'success',
                                    iconPack: 'feather',
                                    icon: 'icon-alert-circle'
                                })
                            }
                            else
                            {
                                this.$vs.notify({
                                    title: 'Error',
                                    text: dados.message,
                                    color: 'danger',
                                    iconPack: 'feather',
                                    icon: 'icon-alert-circle'
                                })
                            }

                        });
                        
                    } else {
                        this.$vs.notify({
                            title: 'Error',
                            text: 'Digite o PIN',
                            color: 'warning',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    }
                })
            })
        }
    },
    created() {
        const thisIns = this;
        fetch(this.$store.state.API_URL + 'Info/Home', {
            method: 'POST',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded' },
            body: "token="+localStorage.getItem("token")
        })
        .then((response) => response.text())
        .then((responseData) => {

            var dados = JSON.parse(responseData);
            thisIns.saldo = dados.meus_dados.saldo;

        });
      },
    components: {
        ItemListView,
        FormWizard,
        TabContent
    },
    directives: {money: VMoney}
}
</script>

<style lang="scss" scoped>
#ecommerce-checkout-demo {
    .item-view-primary-action-btn {
        color: #2c2c2c !important;
        background-color: #f6f6f6;
    }

    .item-name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        -webkit-line-clamp: 2;
    }

    .vue-form-wizard {
        /deep/ .wizard-header {
            padding: 0;
        }

        /deep/ .wizard-tab-content {
            padding-right: 0;
            padding-left: 0;
        }
    }
}
</style>
